'use client';

import { Container, Box } from '@mui/material';
import styled from '@emotion/styled';
import { color, spacing } from 'src/theme/tokens';
import FooterContact from './footer/FooterContact';
import FooterLegal from './footer/FooterLegal';
import FooterNav from './footer/FooterNav';
import { locationsGroup, sitemapGroup } from './footer/footer.config';
import { usePathname } from 'next/navigation';
import { useLocale } from 'next-intl';
import GGAutosalesPageFooter from './GGAutosales/GGAutosalesPageFooter';

const FooterRoot = styled.footer`
    background: ${color.gray[60]};
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: auto;
`;

function Footer() {
    const pathname = usePathname();
    const locale = useLocale();

    // Render the GGAutosalesPageFooter component on the autosales pages:
    const isGGAutosalesPage = pathname.startsWith(`/${locale}/gg-autosales`) || pathname.startsWith(`/${locale}/gg-autosales-terms`);

    if (isGGAutosalesPage) {
        return <GGAutosalesPageFooter />;
    }

    return (
        <FooterRoot role="contentinfo" data-surface="footer">
            <Container>
                <Box
                    display="flex"
                    flexDirection="column"
                    px={0}
                    py={{ xs: spacing[24], sm: spacing[32], md: spacing[40] }}
                    maxWidth="1392px"
                    mx="auto"
                    sx={{ gap: { xs: '48px', sm: spacing[64], md: spacing[80] } }}
                >
                    <Box
                        display="grid"
                        gridTemplateColumns={{ xs: '1fr', sm: '1fr 1fr' }}
                        columnGap={{ xs: spacing[24], md: spacing[32] }}
                        rowGap={{ xs: spacing[48], sm: 0 }}
                        width="100%"
                    >
                        <Box>
                            <FooterContact />
                        </Box>
                        <Box display="flex" flexWrap="nowrap" sx={{ justifyContent: { xs: 'flex-start', md: 'flex-end' }, gap: { xs: spacing[24], md: spacing[32] } }}>
                            <FooterNav group={sitemapGroup} />
                            <FooterNav group={locationsGroup} />
                        </Box>
                    </Box>
                    <FooterLegal />
                </Box>
            </Container>
        </FooterRoot>
    );
}

export default Footer;
